import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import './WhyVorpoint.css';
import foto2 from '../assets/ahmed-office.webp';

function WhyVorpoint() {
  const { t } = useTranslation();
  const advantages = t('why_vorpoint.advantages', { returnObjects: true });

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, x: -30 },
    visible: { opacity: 1, x: 0, transition: { duration: 0.5 } }
  };

  return (
    <section className="why-vorpoint">
      <div className="why-vorpoint-container">
        <motion.h2
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          {t('why_vorpoint.title')}
        </motion.h2>
        <div className="content-and-image">
          <motion.div
            className="advantages-grid"
            variants={containerVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.2 }}
          >
            {advantages.map((advantage, index) => (
              <motion.div key={index} className="advantage-item" variants={itemVariants}>
                <h3>{advantage.title}</h3>
                <p>{advantage.description}</p>
              </motion.div>
            ))}
          </motion.div>
          <motion.div
            className="why-vorpoint-image-container"
            initial={{ opacity: 0, scale: 0.8 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <motion.img
              src={foto2}
              alt={t('why_vorpoint.title')}
              className="why-vorpoint-image"
              animate={{ y: [0, -10, 0] }}
              transition={{ repeat: Infinity, duration: 4, ease: "easeInOut" }}
            />
          </motion.div>
        </div>
      </div>
    </section>
  );
}

export default WhyVorpoint;
